import React from "react";

export default class Pulse extends React.Component {
  render() {
    return (
      <div className="healthcheck">
        <h2>하단의 맥박측정기에서 맥박을 측정해주세요</h2>
        <div className="healthcheck-container">
          <div className="healthcheck-tb">
            <div className="healthcheck-td" id="s-cover">
              <div className="healthcheck-button">
                <img
                  src="https://img.icons8.com/fluent/48/000000/heart-with-pulse.png"
                  alt="맥박"
                />
              </div>
            </div>
            <div className="healthcheck-td">
              <input
                type="text"
                placeholder="맥박"
                name="pulse"
                required
                // readOnly
                defaultValue="60"
                onChange={this.props.change}
              />
            </div>
            <div className="healthcheck-td">
              <p>회</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
